module.exports = ReactBootstrap;


//////////////////
// WEBPACK FOOTER
// external "ReactBootstrap"
// module id = 82
// module chunks = 0